import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const Empresas = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryItems = [
    {
      image: "https://celebratufiesta.com.co/wp-content/uploads/2025/04/123.jpg",
      link: "https://esgrymallc.com/",
      title: "ESGRYMA LLC",
    },
    {
      image: "https://celebratufiesta.com.co/wp-content/uploads/2025/04/121.jpg",
      link: "https://esgrymaconsulting.com/",
      title: "ESGRYMA CONSULTING GROUP",
    },
    {
      image: "https://celebratufiesta.com.co/wp-content/uploads/2025/04/122.jpg",
      link: "https://eleganceintlrealty.com/",
      title: "ELEGANCE INT REALTY",
    },
    {
      image: "https://celebratufiesta.com.co/wp-content/uploads/2025/04/124.jpg",
      link: "https://esgryma.edu.co/",
      title: "INSTITUCION ESGRYMA",
    },
    {
      image: "https://celebratufiesta.com.co/wp-content/uploads/2025/04/125.jpg",
      link: "https://cursosdeseguridadonline.com/",
      title: "CURSOS DE SEGURIDAD ONLINE ",
    },
  ];

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? galleryItems.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === galleryItems.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="relative flex flex-col items-center justify-center py-8 w-full bg-black">
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-700 text-transparent bg-clip-text mb-6 text-center px-4">
        Nuestras Empresas
      </h2>

      <div className="relative flex items-center justify-center w-full max-w-6xl px-4 sm:px-6 md:px-10">
        <div className="relative w-full flex flex-col items-center justify-center p-4 sm:p-6 rounded-lg shadow-lg overflow-hidden">
          <AnimatePresence mode="wait">
          <motion.div
  key={currentIndex}
  className="w-full max-w-[90vw] sm:max-w-[500px] md:max-w-[700px] xl:max-w-[850px] 2xl:max-w-[1000px] 
    aspect-[16/9] mb-4 
    rounded-2xl overflow-hidden relative 
    border-4 border-[#FFD100] ring-4 ring-white ring-offset-4 ring-offset-[#FFD100]
    shadow-yellow-400 drop-shadow-[0_0_15px_#FFD100] transition-transform duration-300 hover:scale-105"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.5 }}
      >
      <img
      src={galleryItems[currentIndex].image}
      alt="Gallery Item"
      className="w-full h-full object-cover rounded-2xl"
      />
        {/* Flecha izquierda */}
        <button
          className="absolute left-1 sm:left-3 top-1/2 -translate-y-1/2 
            bg-black/50 text-white border border-[#FFD100] 
            ring-1 ring-white ring-offset-1 ring-offset-[#FFD100] 
            drop-shadow-[0_0_4px_#FFD100] 
            w-6 h-6 sm:w-10 sm:h-10 flex items-center justify-center z-50 rounded"
          onClick={handlePrev}
        >
          <ChevronLeft size={14} className="sm:size-18" />
        </button>

        {/* Flecha derecha */}
        <button
          className="absolute right-1 sm:right-3 top-1/2 -translate-y-1/2 
            bg-black/50 text-white border border-[#FFD100] 
            ring-1 ring-white ring-offset-1 ring-offset-[#FFD100] 
            drop-shadow-[0_0_4px_#FFD100] 
            w-6 h-6 sm:w-10 sm:h-10 flex items-center justify-center z-50 rounded"
          onClick={handleNext}
        >
          <ChevronRight size={14} className="sm:size-18" />
        </button>

            </motion.div>
          </AnimatePresence>

          {/* Título */}
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-700 text-transparent bg-clip-text mb-4 text-center px-2">
            {galleryItems[currentIndex].title}
          </h3>

          {/* Botón CTA */}
          <AnimatePresence mode="wait">
            <motion.a
              key={currentIndex}
              href={galleryItems[currentIndex].link}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-red-600 text-white font-bold py-3 px-8 sm:py-4 sm:px-10 rounded-lg text-sm sm:text-lg hover:bg-red-700"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3, delay: 0.2 }}
            >
              MÁS INFORMACIÓN
            </motion.a>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default Empresas;
